import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Report } from '~lmo/models/report.model';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-well-status-warning',
  styleUrls: ['./lmo-well-status-warning.component.scss'],
  templateUrl: './lmo-well-status-warning.component.html',
})
export class LmoWellStatusWarningComponent implements OnInit {
  @Input() public report: Report;
  constructor() {}

  public ngOnInit() {}
}
